var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},_vm._l((_vm.list),function(item,index){return _c('GROUPSTAGVUE',_vm._b({key:index,staticClass:"list",attrs:{"isPc":_vm.isPc}},'GROUPSTAGVUE',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }